<template>
  <router-link to="/dashboard">
    <img
      class="img-fluid for-light"
      src="../../assets/images/logo/sfa_logo.svg"
      alt=""
    /><img
      class="img-fluid for-dark"
      src="../../assets/images/logo/sfa_logo.svg"
      alt=""
    />
  </router-link>
</template>
<script>

  export default {
    name: 'Logo',
  };
</script>
